module.exports = __webpack_public_path__ + "img/5ac_30.c63c4bcc.gif";